import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';
import { ChatService } from 'src/app/core/chat.service';
import { FlashcardService } from 'src/app/core/flashcard.service';
import { LearnsetService } from 'src/app/core/learnset.service';
import { UserService } from 'src/app/core/user.service';
import { Flashcard } from 'src/app/models/flashcard.model';
import { Learnset } from 'src/app/models/learnset.model';

@Component({
  selector: 'app-learn-view',
  templateUrl: './learn-with-ai.component.html',
  styleUrls: ['./learn-with-ai.component.scss'],
  standalone: false
})
export class LearnWithAiComponent {

  messages: { sender: 'user' | 'ai', content: string, pending: boolean }[] = [];
  text: string = '';

  generatingSessions: boolean = false;
  
  learnset?: Learnset;

  stack?: Flashcard[];
  side: 'front' | 'back' = 'front';
  totalCount: number = 0;

  isLoading: boolean = false;
  sessionId?: number;

  cardsProgress: number = 0;
  cumulativeScore: number = 0;

  constructor(
    private learnsetService: LearnsetService,
    private flashcardService: FlashcardService,
    private chatService: ChatService,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    const learnsetId = this.route.snapshot.paramMap.get('id');
    this.fetchLearnset(learnsetId!);

    this.initSession(Number(learnsetId!));
    this.messages.push({ sender: 'ai', content: '', pending: true });
    let username: string;
    this.userService.getUser().subscribe((user) => username = user?.firstName ? user.firstName : '');
    setTimeout(() => {
      this.messages.pop();
      this.messages.push({ sender: 'ai', content: `Hi, ${username}. Bist du bereit, deine Lernkarten zu lernen?`, pending: false });
    }, 1000);
  }

  initSession(learnsetId: number) {
    this.chatService.initLearnChat(learnsetId).subscribe((result) => this.sessionId = result.sessionId);
  }

  handleSend() {
    this.messages.push({ sender: 'user', content: this.text.toString(), pending: false });
    setTimeout(() => {
      this.messages.push({ sender: 'ai', content: '...', pending: true });
    }, 1000);
    this.chatService.postLearnMessage(this.sessionId!, this.text).subscribe((result) => {
      this.messages.pop();
      this.messages.push({ sender: 'ai', content: result.response, pending: false });
      this.cardsProgress = result.finishedCards * (100 / result.totalCards);
      this.cumulativeScore = result.totalScore;
    });
    this.text = '';
  }

  fetchLearnset(learnsetId: string): void {
    this.learnsetService.getLearnset(learnsetId)
      .subscribe((learnset: any) => {
        this.learnset = Learnset.constructLearnset(learnset);
        this.stack = JSON.parse(JSON.stringify(this.learnset.flashcards.filter((flashcard) => flashcard.dueDate! < new Date())));
        this.totalCount = this.stack!.length;
      });
  }

  changeSide() {
    this.side = this.side === 'front' ? 'back' : 'front';
  }

  next(grade: number) {
    this.isLoading = true;
    let flashcard: Flashcard = this.stack![0];
    this.flashcardService.updateFlashcardAfterPractice(flashcard, true, grade).subscribe((result) => {
      flashcard = result;
      
      if (flashcard.dueDate! < new Date()) {
        // Wiederholen
        this.stack!.splice(0, 1);
        this.stack?.splice(9, 0, flashcard)
      } else {
        // Entfernen
        this.stack!.splice(0, 1);
      }
      this.side = 'front';
      this.isLoading = false;
    });
  }

  finishSession() {
    this.router.navigate(['/sets/' + this.learnset?.id])
  }
}
